// extracted by mini-css-extract-plugin
export default {"SwipeableContainer":"MHCarousel_SwipeableContainer__RAW30","CarouseContent":"MHCarousel_CarouseContent__0a5a4"};